import React from "react";
import { useHistory } from "react-router-dom";
import { Button } from "primereact/button";
import EvaluationButton from "../shared/EvaluationButton/EvaluationButton";
import Notifications from "../shared/Notifications/Notifications";
import useDashboardPermissions from "../../hooks/useDashboardPermissions";
import localeText from "../../../../locale";
import "./DashboardTopbar.css";
import { useThemeContext } from "../../../../contexts/ThemeContext/ThemeContext";

const DashboardTopbar = ({ userInfo, userTypeInfo }) => {
  const history = useHistory();
  const { canViewFeature } = useDashboardPermissions(userTypeInfo);

  const { subnetInfo } = useThemeContext();
  const showBusinessSquare = userTypeInfo === "Manager" && !!subnetInfo;

  const getInitials = (firstname, surname) => {
    const first = firstname?.charAt(0)?.toUpperCase() || "";
    const second = surname?.charAt(0)?.toUpperCase() || "";
    return `${first}${second}` || "U";
  };

  const handleProfileClick = () => {
    history.push("/dashboard-editprofile");
  };

  const handleShopClick = () => {
    history.push("/shop");
  };

  return (
    <div className="dashboard-topbar-section hidden md:block">
      <div className="dashboard-topbar-content">
        <div className="dashboard-topbar-profile" onClick={handleProfileClick}>
          <div className="dashboard-topbar-profile-avatar">
            {userInfo?.urlAvatar ? (
              <img src={userInfo.urlAvatar} alt="user-avatar" />
            ) : (
              <div className="dashboard-topbar-profile-initials">
                {getInitials(userInfo?.firstname, userInfo?.surname)}
              </div>
            )}
          </div>
          <div className="dashboard-topbar-profile-info">
            <div className="dashboard-topbar-profile-name">
              {userInfo?.firstname} {userInfo?.surname}
            </div>
            <div className="dashboard-topbar-profile-welcome">
              {showBusinessSquare
                ? localeText("dashboardWelcomeMessage") + subnetInfo?.name
                : localeText("welcomeToExtraconomy")}
            </div>
          </div>
        </div>

        <div className="dashboard-topbar-actions">
          <Notifications />
          {canViewFeature("evaluationButton") && (
            <EvaluationButton showBusinessSquare={showBusinessSquare} visible={true} />
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardTopbar;
